import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { actionforms } from './api';

const initialState = {
  helpcenterloading: false,
  paginationList: [],
  scrollingData: []
};

const actions = {
  SUBMIT_HELP_REQUEST: 'submitHelpRequest/SUBMIT_HELP_REQUEST'
};

export const submitHelpRequest = createAsyncThunk(
  actions.SUBMIT_HELP_REQUEST,
  async (payload) => {
    const response = await actionforms(`submit-request`, payload);
    return response;
  }
);

export const HelpCenterSlice = createSlice({
  name: 'helpcenter',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // createForm
    builder
      .addCase(submitHelpRequest.pending, (state) => {
        state.helpcenterloading = true;
      })
      .addCase(submitHelpRequest.fulfilled, (state, action) => {
        const { data } = action.payload;
        // console.log('payload_data', data);
        state.scrollingData = data;
        state.helpcenterloading = false;
      })
      .addCase(submitHelpRequest.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.helpcenterloading = false;
        message.error(msg);
      });
  }
});

export default HelpCenterSlice.reducer;
